import TabPage from "./../factories/tab-page";
import "./../services/bao-menu";
import "./../services/bao-router";
import "./../bindings/bao-tabs";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-upload";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
export class SoftwareLicenseTabViewModel {
    tabPage;
    parent;
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");
    _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicence");
    Bao = Bao;
    SoftwareLicenseCollection = ko.observableArray([]);
    ToolbarButtons = ko.observableArray();
    SelectedRow = ko.observable<any>({});
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    constructor(tabPage, parent) {
        this.tabPage = tabPage;
        this.parent = parent;
        this.initSubscriptions();
    }
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddSoftwareLicense":
                this.AddSoftwareLicense();
                break;
            case "DeleteSoftwareLicense":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, this._deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result == true) {
                        this.DeleteSoftwareLicense();
                    }
                });
                break;
            case "EditSoftwareLicense":
                this.EditSoftwareLicense();
                break;
            case "RefreshSoftwareLicense":
                this.Refresh();
                break;
        }
    };
    initSubscriptions = () => {
        this.SelectedRow.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.PageIndex.subscribe(() => {
            this.Refresh();
        });
    };
    ToggleToolbarButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            if (button.ActionKey() == "AddSoftwareLicense") {
                button.Enabled(!this.parent.IsNew());
            }
            if (button.ActionKey() == "RefreshSoftwareLicense") {
                button.Enabled(!this.parent.IsNew());
            }
            if (button.ActionKey() == "EditSoftwareLicense") {
                button.Enabled(!this.parent.IsNew() && this.SelectedRow() != null);
            }
            if (button.ActionKey() == "DeleteSoftwareLicense") {
                button.Enabled(this.SelectedRow() != null);
            }
        });
    };
    AddSoftwareLicense = () => {
        baoRouter.setHash("#license/new/" + ko.unwrap(this.parent.SoftwareLicencePoolId()));
    };
    EditSoftwareLicense = () => {
        baoRouter.setHash("#license/" + ko.unwrap(this.SelectedRow().SoftwareLicenceId));
    };
    DeleteSoftwareLicense = () => {
        this.tabPage.IsLoading(true);
        return Bao.post("License/DeleteSoftwareLicensePoolFromSoftwareLicense", JSON.stringify({
            softwareLicenceModel: ko.map.toJS(this.SelectedRow())
        }), () => {
            this.Refresh();
        });
    };
    Refresh = () => {
        this.tabPage.IsLoading(true);
        return Bao.post("License/GetSoftwareLicenseCollection", JSON.stringify({
            softwareLicencePoolId: this.parent.SoftwareLicencePoolId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: null
        }), (searchResult) => {
            this.SelectedRow(null);
            this.TotalRows(0);
            this.SoftwareLicenseCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.SoftwareLicenseCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
                this.ToggleToolbarButtons();
            }
            this.tabPage.IsLoading(false);
        });
    };
}
;
export class SoftwareLicensePoolDocumentTabViewModel {
    tabPage;
    parent;
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");
    _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicenceDocument");
    Dialog;
    Bao = Bao;
    DocumentCollection = ko.observableArray([]);
    ToolbarButtons = ko.observableArray();
    SelectedRow = ko.observable<any>({});
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    constructor(tabPage, parent) {
        this.tabPage = tabPage;
        this.parent = parent;
        this.initSubscriptions();
        this.setDocumentDialog();
    }
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddSoftwareLicensePoolDocument":
                this.ShowSoftwareLicensePoolDocumentDialog(this.parent.SoftwareLicencePoolId());
                break;
            case "DeleteSoftwareLicensePoolDocument":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, this._deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result == true) {
                        this.DeleteSoftwareLicensePoolDocument();
                    }
                });
                break;
            case "RefreshSoftwareLicensePoolDocument":
                this.Refresh();
                break;
            case "DownloadSoftwareLicensePoolDocument":
                this.DownloadSoftwareLicensePoolDocument();
                break;
        }
    };
    initSubscriptions = () => {
        this.SelectedRow.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.PageIndex.subscribe(() => {
            this.Refresh();
        });
    };
    ToggleToolbarButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            if (button.ActionKey() == "DeleteSoftwareLicensePoolDocument") {
                button.Enabled(this.SelectedRow() != null);
            }
            if (button.ActionKey() == "DownloadSoftwareLicensePoolDocument") {
                button.Enabled(this.SelectedRow() != null);
            }
        });
    };
    setDocumentDialog = () => {
        this.Dialog = new BaoDialog(Bao.Session.GetMessage("msgDocument"));
        this.Dialog.Width("450px");
        this.Dialog.Buttons([{
                Title: this._msgOk,
                Click: () => {
                    if (this.Dialog.ViewModel().SoftwareLicencePoolDocumentId() != null) {
                        this.Dialog.IsLoading(true);
                        $.when(this.Dialog.ViewModel().Upload()).then(() => {
                            this.Dialog.IsLoading(false);
                            this.AddSoftwareLicensePoolDocument(this.Dialog.ViewModel());
                            this.Dialog.Close();
                        });
                    }
                    else {
                        new BaoDialog(Bao.Session.GetMessage("msgDocument"), Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                    }
                }, Enabled: ko.observable(true)
            }, { Title: this._msgCancel, Click: () => { this.Dialog.Close(); }, Enabled: ko.observable(true) }]);
    };
    ShowSoftwareLicensePoolDocumentDialog = (softwareLicencePoolId) => {
        Bao.post("SoftwareLicensePool/ShowSoftwareLicensePoolDocumentDialog", JSON.stringify({
            sessionTabId: this.parent.TabPage.SessionTabId,
            softwareLicencePoolId: softwareLicencePoolId
        }), (value) => {
            var dialogModel = ko.map.fromJS(value.Model);
            dialogModel.Upload = function () { };
            this.Dialog.ViewModel(dialogModel);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
        });
    };
    AddSoftwareLicensePoolDocument = (model) => {
        this.tabPage.IsLoading(true);
        return Bao.post("SoftwareLicensePoolDocument/AddSoftwareLicensePoolDocument", JSON.stringify({
            sessionTabId: this.parent.TabPage.SessionTabId,
            softwareLicencePoolId: this.parent.SoftwareLicencePoolId(),
            softwareLicensePoolDocument: ko.map.toJS(model)
        }), () => {
            this.parent.TabPage.DirtyFlag(true);
            this.Refresh();
        });
    };
    DeleteSoftwareLicensePoolDocument = () => {
        this.tabPage.IsLoading(true);
        return Bao.post("SoftwareLicensePoolDocument/DeleteSoftwareLicensePoolDocument", JSON.stringify({
            sessionTabId: this.parent.TabPage.SessionTabId,
            softwareLicencePoolDocumentId: this.SelectedRow().SoftwareLicencePoolDocumentId
        }), () => {
            this.parent.TabPage.DirtyFlag(true);
            this.Refresh();
        });
    };
    DownloadSoftwareLicensePoolDocument = () => {
        window.open("SoftwareLicensePoolDocument/DownloadSoftwareLicensePoolDocument?id=" + this.SelectedRow().SoftwareLicencePoolDocumentId);
    };
    Refresh = () => {
        this.tabPage.IsLoading(true);
        return Bao.post("SoftwareLicensePoolDocument/GetSoftwareLicensePoolDocumentCollection", JSON.stringify({
            sessionTabId: this.parent.TabPage.SessionTabId,
            softwareLicencePoolId: this.parent.SoftwareLicencePoolId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: null
        }), (searchResult) => {
            this.SelectedRow(null);
            this.TotalRows(0);
            this.DocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.DocumentCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
                this.ToggleToolbarButtons();
            }
            this.tabPage.IsLoading(false);
        });
    };
}
class SoftwareLicensePool extends BaseViewModel {
    SoftwareLicencePoolId: KnockoutObservable<string> = ko.observable<string>();
    SoftwareId: KnockoutObservable<string> = ko.observable<string>();
    SoftwareName: KnockoutObservable<string> = ko.observable<string>();
    SoftwareTypeName: KnockoutObservable<string> = ko.observable<string>();
    CustomerId: KnockoutObservable<string> = ko.observable<string>();
    CustomerName: KnockoutObservable<string> = ko.observable<string>();
    DepartmentId: KnockoutObservable<string> = ko.observable<string>();
    DepartmentName: KnockoutObservable<string> = ko.observable<string>();
    LicenceKey: KnockoutObservable<string> = ko.observable<string>();
    CountOfLicences: KnockoutObservable<number> = ko.observable<number>();
    OrderDateJS: KnockoutObservable<any> = ko.observable();
    OrderNumber: KnockoutObservable<number> = ko.observable<number>();
    SearcherSoftware: Bindings.baoSearcher = {
        ObjectId: this.SoftwareId,
        ObjectValue: 'Name',
        SearchType: 'Software',
        AutoSearch: true,
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false },
        Enabled: true,
        CustomFilter: {}
    };
    SearcherCustomer: Bindings.baoSearcher = {
        ObjectId: this.CustomerId,
        ObjectValue: 'Name1HtmlSafe',
        SearchType: 'Customers',
        AutoSearch: true,
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false },
        Enabled: true,
        CustomFilter: {}
    };
    SearcherDepartment: Bindings.baoSearcher = {
        ObjectId: this.DepartmentId,
        ObjectValue: 'Department',
        SearchType: 'Department',
        AutoSearch: true,
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false },
        Enabled: true,
        CustomFilter: {}
    };
    DateTimeBoxOrderDate: Bindings.baoDateTimeBox = {
        value: this.OrderDateJS,
        culture: Bao.Session.Language.Symbol()
    };
    DateTimePickerOrderDate: Bindings.baoDateTimePicker = {
        mode: 'date',
    };
    NumberBoxCountOfLicences: Bindings.baoNumberBox = {
        value: this.CountOfLicences,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    TabViewModel = new TabController(false);
    SoftwareLicenseTab = new TabPage();
    DocumentTab = new TabPage();
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (!this.SoftwareName() || !this.CountOfLicences()) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    InitUrl(): string {
        return "SoftwareLicensePool/Init";
    }
    Save() {
        return super.Save().then(() => {
            this.TabPage.IsLoading(true);
            Bao.post("SoftwareLicensePool/SaveSoftwareLicensePoolDocuments", JSON.stringify({
                sessionTabId: this.TabPage.SessionTabId
            }), (value) => {
                this.PerformRefresh(true);
                if (this.DocumentTab) {
                    this.DocumentTab.ViewModel().Refresh();
                }
                if (this.SoftwareLicenseTab) {
                    this.SoftwareLicenseTab.ViewModel().Refresh();
                }
            });
        });
    }
    loaded() {
        this.TabViewModel.AddTab(this.SoftwareLicenseTab);
        this.TabViewModel.AddTab(this.DocumentTab);
        this.TabViewModel.SelectTab(this.SoftwareLicenseTab);
        this.SoftwareId.subscribe((value) => {
            if (value) {
                Bao.post("Software/Get", JSON.stringify({
                    id: value
                }), (returnValue) => {
                    Bao.post("SoftwareType/Get", JSON.stringify({
                        id: returnValue.SoftwareTypeId
                    }), (model) => {
                        this.SoftwareTypeName(model ? model.Name : "");
                    });
                });
            }
        });
        return super.loaded();
    }
    init(): JQueryPromise<void> {
        this.InitTabPages();
        return super.init();
    }
    private InitTabPages() {
        this.SoftwareLicenseTab.AutoSelect = false;
        this.SoftwareLicenseTab.Url("SoftwareLicensePool/SoftwareLicensePoolSoftwareLicenseTab");
        this.SoftwareLicenseTab.Title = Bao.Session.GetMessage("msgSoftwareLicense");
        this.SoftwareLicenseTab.IsClosable(false);
        this.SoftwareLicenseTab.ViewModel(new SoftwareLicenseTabViewModel(this.SoftwareLicenseTab, this));
        this.SoftwareLicenseTab.TabLoaded = () => {
            this.SoftwareLicenseTab.ViewModel().Refresh();
        };
        this.DocumentTab.AutoSelect = false;
        this.DocumentTab.Url("SoftwareLicensePool/SoftwareLicensePoolDocumentTab");
        this.DocumentTab.Title = Bao.Session.GetMessage("msgReferenceDocuments");
        this.DocumentTab.IsClosable(false);
        this.DocumentTab.ViewModel(new SoftwareLicensePoolDocumentTabViewModel(this.DocumentTab, this));
        this.DocumentTab.TabLoaded = () => {
            this.DocumentTab.ViewModel().Refresh();
        };
    }
}
export default SoftwareLicensePool;